<template>
  <div>
    <article>
      <slot name="header"></slot>
    </article>
    <div class="ut-container-lg ut-pb-2" v-if="user && user.key" v-cloak>
      <div>
        <p>
          Hi {{ user.firstname }},<br /><br />In order to improve the security
          of your agent portal we will now need you to verify your account via
          the email sent to you.<br /><br />
          We have just sent an email to the address linked to your Premier
          account. Please follow the instructions in the email to verify your
          account.<br /><br />
          Note that you only need to do this once per device.<br /><br />
          Thanks,<br />
          The Premier Team
        </p>
      </div>
      <div class="ut-text-center ut-mt-2 ut-font-bold">
        <div>Enter verification code below</div>
        <div
          class="
            ut-inline-block
            ut-my-4
            ut-text-4xl
            ut-border
            ut-rounded-sm
            ut-divide-x
          "
        >
          <input
            ref="OTP1"
            class="ut-p-4 ut-text-center ga-event"
            data-category="Device Verification"
            data-eventlabel="Code Input"
            type="text"
            maxlength="1"
            size="1"
            v-model="OTP1Val"
            @keyup="focusInput($event, 'OTP2')"
          />
          <input
            ref="OTP2"
            class="ut-p-4 ut-text-center  ga-event"
            data-category="Device Verification"
            data-eventlabel="Code Input"
            type="text"
            maxlength="1"
            size="1"
            v-model="OTP2Val"
            @keyup="focusInput($event, 'OTP3')"
            @keyup.delete="deleteInput($event, 'OTP1')"
          />
          <input
            ref="OTP3"
            class="ut-p-4 ut-text-center  ga-event"
            data-category="Device Verification"
            data-eventlabel="Code Input"
            type="text"
            maxlength="1"
            size="1"
            v-model="OTP3Val"
            @keyup="focusInput($event, 'OTP4')"
            @keyup.delete="deleteInput($event, 'OTP2')"
          />
          <input
            ref="OTP4"
            class="ut-p-4 ut-text-center  ga-event"
            data-category="Device Verification"
            data-eventlabel="Code Input"
            type="text"
            maxlength="1"
            size="1"
            v-model="OTP4Val"
            @keyup="focusInput($event, null)"
            @keyup.delete="deleteInput($event, 'OTP3')"
          />
        </div>
        <span v-if="isError" id="error-message" class="error inline">
          {{ errorMsg }}
        </span>
      </div>
      <div class="ut-text-center ut-mt-2 ut-font-bold">
        <div>Didn't receive the verification code?</div>
        <div
          class="ut-text-green-400 hover:ut-underline ut-cursor-pointer ga-event"
            data-category="Device Verification"
          @click="triggerOneTimePassword(true)"
        >
          resend verification code
        </div>
        <span
          v-if="isResendMsg"
          id="resend-message"
          class="ut-text-neutral-300 ut-text-xs inline"
          v-bind:class="{ error: resendError }"
        >
          {{ resendMsg }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import helpers from "@/helpers/common-helpers";

export default {
  name: "UserDeviceVerification",
  components: {},
  props: {
    ak: { required: false },
  },
  data() {
    const isPremier = helpers.getUrlNum("ispremier") === 1 ? 1 : 0;

    return {
      statsLoaded: false,
      premierInfoText: "",
      OTP1Val: "",
      OTP2Val: "",
      OTP3Val: "",
      OTP4Val: "",
      errorMsg: "",
      resendMsg: "",
      resendError: false,
    };
  },
  computed: {
    ...mapState({
      agent: (state) => state.agentStore.agent,
      user: (state) => state.userStore.user,
    }),
    ...mapGetters("userStore", ["isPremier", "isPrincipal", "isManager"]),
    isError() {
      return this.errorMsg !== "";
    },
    isResendMsg() {
      return this.resendMsg !== "";
    },
  },
  created() {
    const isPremierParam = helpers.getUrlNum("ispremier");
    const isPremier = isPremierParam === null ? 1 : isPremierParam;
    this.triggerOneTimePassword();
    this.getSnippets();
  },
  methods: {
    ...mapActions("userStore", [
      "sendUserVerificationCode",
      "verifyUserVerificationCode",
    ]),
    triggerOneTimePassword(resend) {
      this.resendMsg = "";
      this.resendError = false;
      const payload = {
        userkey: this.user.key,
        accountid: this.user.accountid,
      };
      payload.resendrequested = resend ? 1 : 0;
      this.sendUserVerificationCode(payload)
        .then((response) => {
          //show success info
          this.resendMsg = resend
            ? `verification code has been resent to ${this.user.email}`
            : "";
        })
        .catch((error) => {
          this.resendError = true;
          this.resendMsg = error;
        });
    },
    focusInput(event, ref) {
      var charCode = event.keyCode || event.which;
      if (
        (charCode >= 48 && charCode <= 57) || //number
        (charCode >= 96 && charCode <= 105) || //numpad
        (charCode == 229) //Andriod only return 229 keyCode
      ) {
        this.verifyOTP(ref);
      } else {
        event.preventDefault();
      }
    },
    deleteInput(event, ref) {
      this.errorMsg = "";
      if (ref) {
        this.$refs[ref].focus();
      }
    },
    verifyOTP(ref) {
      //check if all code have been filled:
      if (
        this.OTP1Val != "" &&
        this.OTP2Val != "" &&
        this.OTP3Val != "" &&
        this.OTP4Val != ""
      ) {
        let userCode = `${this.OTP1Val}${this.OTP2Val}${this.OTP3Val}${this.OTP4Val}`;
        const payload = {
          userkey: this.user.key,
          accountid: this.user.accountid,
          usercode: userCode,
          userdevice: window.navigator.userAgent,
        };
        this.verifyUserVerificationCode(payload)
          .then((response) => {
            this.$store.dispatch("userStore/loadUser", this.user.key);
          })
          .catch((error) => {
            this.errorMsg = error;
          });
      } else {
        if (ref) {
          this.$refs[ref].focus();
        }
      }
    },
    getSnippets() {
      const data = {
        snippettitlelist:
          "premier-program-i-text,premier-program-i-text-start-date",
      };

      this.$apiServices.oa.article.getSnippets(data).then(
        (snippets) => {
          let startDate = "";

          this.$apiServices.oa.account
            .getPremierStartDate(this.user.key)
            .then((date) => {
              startDate = this.$helpers.convertFromUTC(date);

              this.premierInfoText =
                snippets.length > 1
                  ? decodeURIComponent(snippets[0].snippetbody) +
                    (startDate != ""
                      ? decodeURIComponent(snippets[1].snippetbody).replace(
                          "%PREMIER_START_DATE%",
                          startDate
                        )
                      : "")
                  : null;
            });
        },
        (err) => {
          console.log(err);
          this.premierInfoText = null;
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
input:focus {
  outline: none;
}
.sub-heading {
  @apply ut-mt-12 ut-mb-6 ut-text-xl ut-font-bold;
  letter-spacing: -0.2px;
  line-height: 25px;
}

.heading-badge {
  @apply ut-ml-3 ut-mt-3 ut-rounded ut-text-center ut-block ut-text-neutral-001 ut-bg-green-200;
  height: 18px;
  width: 64px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 18px;

  &:hover {
    cursor: pointer;
  }
}
</style>
